import React from 'react'
import chroma from 'chroma-js'

// US States data
export const states = [
	{ code: 'AL', name: 'Alabama' },
	{ code: 'AK', name: 'Alaska' },
	{ code: 'AZ', name: 'Arizona' },
	{ code: 'AR', name: 'Arkansas' },
	{ code: 'CA', name: 'California' },
	{ code: 'CO', name: 'Colorado' },
	{ code: 'CT', name: 'Connecticut' },
	{ code: 'DE', name: 'Delaware' },
	{ code: 'FL', name: 'Florida' },
	{ code: 'GA', name: 'Georgia' },
	{ code: 'HI', name: 'Hawaii' },
	{ code: 'ID', name: 'Idaho' },
	{ code: 'IL', name: 'Illinois' },
	{ code: 'IN', name: 'Indiana' },
	{ code: 'IA', name: 'Iowa' },
	{ code: 'KS', name: 'Kansas' },
	{ code: 'KY', name: 'Kentucky' },
	{ code: 'LA', name: 'Louisiana' },
	{ code: 'ME', name: 'Maine' },
	{ code: 'MD', name: 'Maryland' },
	{ code: 'MA', name: 'Massachusetts' },
	{ code: 'MI', name: 'Michigan' },
	{ code: 'MN', name: 'Minnesota' },
	{ code: 'MS', name: 'Mississippi' },
	{ code: 'MO', name: 'Missouri' },
	{ code: 'MT', name: 'Montana' },
	{ code: 'NE', name: 'Nebraska' },
	{ code: 'NV', name: 'Nevada' },
	{ code: 'NH', name: 'New Hampshire' },
	{ code: 'NJ', name: 'New Jersey' },
	{ code: 'NM', name: 'New Mexico' },
	{ code: 'NY', name: 'New York' },
	{ code: 'NC', name: 'North Carolina' },
	{ code: 'ND', name: 'North Dakota' },
	{ code: 'OH', name: 'Ohio' },
	{ code: 'OK', name: 'Oklahoma' },
	{ code: 'OR', name: 'Oregon' },
	{ code: 'PA', name: 'Pennsylvania' },
	{ code: 'RI', name: 'Rhode Island' },
	{ code: 'SC', name: 'South Carolina' },
	{ code: 'SD', name: 'South Dakota' },
	{ code: 'TN', name: 'Tennessee' },
	{ code: 'TX', name: 'Texas' },
	{ code: 'UT', name: 'Utah' },
	{ code: 'VT', name: 'Vermont' },
	{ code: 'VA', name: 'Virginia' },
	{ code: 'WA', name: 'Washington' },
	{ code: 'WV', name: 'West Virginia' },
	{ code: 'WI', name: 'Wisconsin' },
	{ code: 'WY', name: 'Wyoming' }
]

// State options for Select component
export const stateOptions = states.map((state) => ({
	value: state.code,
	label: state.name,
	color: chroma.random().hex()
}))

// Custom styles for State Select component
export const stateSelectStyles = {
	control: (styles) => ({ ...styles, backgroundColor: 'white' }),
	option: (styles, { data, isDisabled, isFocused, isSelected }) => {
		const color = chroma(data.color)
		return {
			...styles,
			backgroundColor: isDisabled ? undefined : isSelected ? data.color : isFocused ? color.alpha(0.1).css() : undefined,
			color: isDisabled ? '#ccc' : isSelected ? (chroma.contrast(color, 'white') > 2 ? 'white' : 'black') : data.color,
			cursor: isDisabled ? 'not-allowed' : 'default',
			':active': {
				...styles[':active'],
				backgroundColor: !isDisabled ? (isSelected ? data.color : color.alpha(0.3).css()) : undefined
			}
		}
	},
	multiValue: (styles, { data }) => {
		const color = chroma(data.color)
		return {
			...styles,
			backgroundColor: color.alpha(0.1).css()
		}
	},
	multiValueLabel: (styles, { data }) => ({
		...styles,
		color: data.color
	}),
	multiValueRemove: (styles, { data }) => ({
		...styles,
		color: data.color,
		':hover': {
			backgroundColor: data.color,
			color: 'white'
		}
	})
}

// Column titles for visibility toggle
export const columnTitles = [
	'Unit ID',
	'COLLEGE',
	'STATE',
	'CITY',
	'TYPE',
	'POPULATION',
	'US NEWS RANK',
	'GRD. RATE',
	'RATE',
	'GPA AVG',
	'SAT English',
	'SAT Math',
	'SAT TOT.',
	'In-State Tuition($)',
	'Out-State Tuition($)',
	'URL',
	'NET PRICE CALC URL',
	'Select'
]

// Column definitions for DataTable
export const getStudentCollegeColumns = (prevStudentCollegeList, setStudentCollegeList, effectiveStudentId) => [
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>Unit ID</div>,
		selector: (row) => row.unitid || '-',
		sortable: true,
		width: '80px',
		style: { backgroundColor: '#e3f2fd' } // PHYSICAL SETTINGS color
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>COLLEGE</div>,
		selector: (row) => row.college,
		sortable: true,
		width: '200px',
		style: { backgroundColor: '#e3f2fd' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>STATE</div>,
		selector: (row) => row.state,
		sortable: true,
		width: '50px',
		style: { backgroundColor: '#e3f2fd' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>CITY</div>,
		selector: (row) => row.city,
		sortable: true,
		width: '120px',
		style: { backgroundColor: '#e3f2fd' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>TYPE</div>,
		selector: (row) => row.type,
		sortable: true,
		width: '100px',
		style: { backgroundColor: '#e3f2fd' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>POPULATION</div>,
		selector: (row) => row.population,
		sortable: true,
		width: '100px',
		style: { backgroundColor: '#e3f2fd' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>US NEWS RANK</div>,
		selector: (row) => row.us_news_rank || '-',
		sortable: true,
		width: '50px',
		style: { backgroundColor: '#fff3e0' } // ACADEMICS color
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>GRD. RATE</div>,
		selector: (row) => row.grd_rate || '-',
		sortable: true,
		width: '50px',
		style: { backgroundColor: '#fff3e0' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>RATE</div>,
		selector: (row) => row.rate || '-',
		sortable: true,
		width: '50px',
		style: { backgroundColor: '#f3e5f5' } // ADMISSION color
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>GPA AVG</div>,
		selector: (row) => row.gpa_avg || '-',
		sortable: true,
		width: '50px',
		style: { backgroundColor: '#f3e5f5' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>SAT English</div>,
		selector: (row) => row.sat_english || '-',
		sortable: true,
		width: '70px',
		style: { backgroundColor: '#f3e5f5' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>SAT Math</div>,
		selector: (row) => row.sat_math || '-',
		sortable: true,
		width: '70px',
		style: { backgroundColor: '#f3e5f5' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>SAT TOT.</div>,
		selector: (row) => row.sat_total || '-',
		sortable: true,
		width: '70px',
		style: { backgroundColor: '#f3e5f5' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>In-State Tuition($)</div>,
		selector: (row) => (row.in_state_tuition ? `$${row.in_state_tuition}` : '-'),
		sortable: true,
		width: '100px',
		style: { backgroundColor: '#e8f5e9' } // FINANCE color
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>Out-State Tuition($)</div>,
		selector: (row) => (row.out_state_tuition ? `$${row.out_state_tuition}` : '-'),
		sortable: true,
		width: '100px',
		style: { backgroundColor: '#e8f5e9' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>URL</div>,
		selector: (row) =>
			row.url ? (
				<a
					href={`https://${row.url}`}
					target="_blank"
					rel="noopener noreferrer"
					className="text-primary text-truncate d-block"
					style={{ maxWidth: '150px' }}
					title={row.url}
				>
					{row.url}
				</a>
			) : (
				'-'
			),
		sortable: false,
		width: '150px',
		style: { backgroundColor: '#fce4ec' } // URL color
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>NET PRICE CALC URL</div>,
		selector: (row) =>
			row.net_price_calc_url ? (
				<a
					href={`https://${row.net_price_calc_url}`}
					target="_blank"
					rel="noopener noreferrer"
					className="text-primary text-truncate d-block"
					style={{ maxWidth: '150px' }}
					title={row.net_price_calc_url}
				>
					{row.net_price_calc_url}
				</a>
			) : (
				'-'
			),
		sortable: false,
		width: '150px',
		style: { backgroundColor: '#fce4ec' }
	},
	{
		name: <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>Select</div>,
		cell: (row) => {
			const isSelected = prevStudentCollegeList.some((prev) => prev.collegeId === row.id)
			return (
				<div className="form-check">
					<input
						className="checkbox_animated"
						type="checkbox"
						checked={isSelected}
						onChange={(e) => {
							if (e.target.checked) {
								// Add to selection
								setStudentCollegeList((prev) => [...prev, { collegeId: row.id, studentId: effectiveStudentId }])
							} else {
								// Remove from selection
								setStudentCollegeList((prev) => prev.filter((item) => item.collegeId !== row.id))
							}
						}}
					/>
				</div>
			)
		},
		width: '80px',
		center: true,
		ignoreRowClick: true,
		style: { backgroundColor: '#fff9c4' } // SELECT color
	}
]
